<template>
  <div>
    <v-app light v-if="$route.meta.requiresAuth">
    
      <v-container>
        <v-layout class="fixed" id="module-left" app fill-height>
          <menuPanel/>
        </v-layout>
  
        <v-layout class="fixed" id="module-top" app>
          <headerPanel/>
        </v-layout>

        <v-layout class="fixed" id="module-right" app fill-height>
          <infoPanel />
        </v-layout>

        <v-layout class="fixed" id="module-center" app fill-height>
          <v-container>
              <v-layout @click="animMenu" class="leftTab">
                  <v-flex class="leftTab-image"></v-flex>
              </v-layout>
              <router-view />
          </v-container>
        </v-layout>
      </v-container>
    </v-app>
    <v-app v-else>
      <router-view />
    </v-app>
    
  </div>
</template>


<script>

import Vue from "vue";
import menuPanel from "@/components/portal/layout/MenuPanel";
import headerPanel from "@/components/portal/layout/HeaderPanel";
import infoPanel from "@/components/portal/layout/InfoPanel";
import router from '@/router';
import animations from "@/assets/scripts/animations";


export default {
  components: {
    menuPanel,
    headerPanel,
    infoPanel
  },
  mixins:[animations],
  data() {
    return {
      path: ""
    }
  },  
  methods:{
    autenticado(value){
      if(value){
        window.location.href = "painel"; // push content
        this.path = "painel";
      }

      if(process.env.VUE_APP_API_DEBUG == 'true')
      {
        let codCorretor = localStorage.getItem("codCor");
        if(codCorretor == null || codCorretor == '' || codCorretor == 0)
        {
          if (this.path != '/') { this.path = '/'; }
        }
      }      
    },   
  },
  created() {
    Vue.prototype.getApp = this;
    Vue.prototype.getRoot = this.$root;
    Vue.prototype.getRouter = this.$router;

    // Retoma o polling de processamentos de arquivo (Prestamista/SQG/DFI) que ficaram
    // pendentes de uma sessão anterior (persistidos no localStorage) - sem isso, um
    // reload de página deixaria o rastreamento parado até um novo upload.
    this.$store.dispatch("processamentos/garantirPolling");
  },  };
</script>